import Vue from 'vue';
import Vuex, { Module, ModuleTree } from 'vuex';
import adminStore, { IAdminState } from './admin-store';
import authStore, { IAuthState } from './auth-store';
import userStore, { IUserState } from './user-store';
import groupStore, { IGroupState } from './group-store';
import appStore, { IAppState } from './app-store';


Vue.use(Vuex);

export interface IRootState {
  auth: IAuthState;
  app: IAppState;
  admin: IAdminState;
  user: IUserState;
  group: IGroupState;
}

const modules: ModuleTree<IRootState> = {
  auth: authStore,
  app: appStore,
  admin: adminStore,
  user: userStore,
  group: groupStore,
};

const store = new Vuex.Store({ modules });

export default store;
